// extracted by mini-css-extract-plugin
module.exports = {"refurbished-C":"C_refurbished-C__xyMdx"};